import $ from 'jquery';
import slick from  '../vendors/slider.min';

class BjzmScripts {
	
	constructor() {
		 this.do_hamburger();
		 this.doSliders();
		 this.isHamburgerOpen = false;
		 this.setTouchScreenClasses(".button, .navigation__link");
		 this.mobileHeader = $(".header--mobile");
		 this.desktHeader = $('.header--main');
		 this.topDist = '';
		 this.body = $('body');

		this.projFilter = {
			button : $('.button--filter'),
			card : $('.card'),
			el : '',
			targets : ''
		}

		this.projFilter.button.on('click', (e) =>{			
			e.preventDefault();	
			// this.animateFilters($('.cards--projects'), 'fadeInOut', 400);
			// setTimeout(() => {
				this.doFilters(e);
			// }, 300);
		});


		$(".bjzm-slideshow__list").on('beforeChange', (event, slick, currentSlide, nextSlide, sliderId, sliderType) => {
			this.sliderCounter(event, slick, currentSlide, nextSlide, sliderId, sliderType);
		});

	}

	doFilters(e){
		this.projFilter.el = $(e.currentTarget);

		$('.filter').find('.button__under').addClass('hidden');
		$('.filter').removeClass('filter--other');
		this.projFilter.el.find('.button__under').removeClass('hidden');

		let targets = this.projFilter.el.attr('data-target');

		if (targets != this.projFilter.targets){

			this.projFilter.targets = targets;

			if(this.projFilter.targets == 'all'){

				this.projFilter.card.removeClass('card--hidden').removeClass('animated').attr('style','');

			} else {
				this.projFilter.card.addClass('card--hidden').removeClass('animated').attr('style','');
				$('.' + this.projFilter.targets).removeClass('card--hidden').removeClass('animated').attr('style','');

			}

		}
		setTimeout(function() { $(window).trigger('scroll'); }, 400);
	}


	animateFilters(target, attr, time){
		target.addClass(attr);
		setTimeout(function(){
			target.removeClass(attr);
		}, time);
	}



	do_hamburger() {
		var self = this;
		$(".hamburger__inner").click(function(e){
			e.preventDefault();
			if( self.isHamburgerOpen ) {
				self.closeMobileMenu();
			}
			else {
				self.openMobileMenu();
			}
		});
		$('.navigation--desktop').on('click',function(e){
			if ($(e.target).hasClass('navigation--desktop')) {
				self.closeMobileMenu();
			}
		});	
	}

	doSliders() {
		if( $(".bjzm-slideshow__list").length > 0 ) {
			
			$(".bjzm-slideshow__list").slick({ 
				dots: false,
				//centerPadding: '20px',
		 		//slidesToShow: 1,
		 		//slidesToScroll: 1,
		 		//variableWidth: true,
		 		speed: 150,
		 		// adaptiveHeight: false,
		 		arrows: false,
	            dotsClass: 'custom_paging',
	            infinite: true,
	            // autoplay: false,
	            //autoplaySpeed: 3000,
	            // pauseOnHover: true,
	            // useCSS: true,
	            //centerMode: true,
	            fade: true,
	            cssEase: 'ease-in-out'
		 	});
			$(".bjzm-slideshow__nav-link--prev").on('click', function(e){
				e.preventDefault();
				$(".bjzm-slideshow__list").slick('slickPrev');
			})
			$(".bjzm-slideshow__nav-link--next").on('click', function(e){
				e.preventDefault();
				$(".bjzm-slideshow__list").slick('slickNext');
			})

		} 	
	}

	sliderCounter(event, slick, currentSlide, nextSlide, sliderId, sliderType){
		var slideIndex = nextSlide + 1;
		var i = (nextSlide ? nextSlide : 0) + 1;
		let el = $('.bjzm-slideshow__count');
		$(el).addClass('go-out');
		setTimeout(function(){
			$(el).removeClass('go-out');
			$(el).addClass('go-in');
			$(el).html(`${i}`);
		}, 100);
		setTimeout(function(){
			$(el).removeClass('go-out');
			$(el).addClass('go-in');
			$(el).html(`${i}`);
		}, 100);
	}

	openMobileMenu() {
		this.topDist = $(window).scrollTop();

		this.mobileHeader.addClass("header--mobile-menu-active");
		this.desktHeader.addClass('header--main-menu-active');
		this.desktHeader.removeClass('header--main-menu-inactive');
		setTimeout(() => {
			this.body.addClass('scroll-lock');
		}, 300);

		this.isHamburgerOpen = true;
	}

	closeMobileMenu() {
		this.mobileHeader.removeClass("header--mobile-menu-active");
		this.desktHeader.removeClass('header--main-menu-active');
		this.desktHeader.addClass('header--main-menu-inactive');

		this.body.removeClass('scroll-lock');
		window.scrollTo(0, this.topDist);

		this.isHamburgerOpen = false;
	}


	is_touch_device() {
		return (('ontouchstart' in window)
			|| (navigator.MaxTouchPoints > 0)
			|| (navigator.msMaxTouchPoints > 0));
	}

	getTouchClass() {
		return ( this.is_touch_device() ) ? ' touch-screen' : ' desktop-screen';
	}

	setTouchScreenClasses(selectors) {

		var classes = this.getTouchClass();
		$(selectors).addClass( classes );
	}

	

	
}

module.exports = BjzmScripts;